import { createQueryKeys } from '@lukemorales/query-key-factory';

import { getFeeForOfferId, getFeeForOfferTotal } from '../clients/fee.api';
import {
    getInitialEnquiry,
    getMessages,
    getMessagesForOfferId,
    getOfferById,
    getOfferHistory,
    getOfferList,
    GetOfferListParams,
    getOffers,
    GetOffersParams,
} from '../clients/gateway.api';
import { getOfferApprovalSettings } from '../clients/offerApproval.api';
import { validateOffer } from '../clients/order.api';

interface GetOffersTotalsParams {
    searchQuery?: string;
    supplierIds?: string[];
    customerIds?: string[];
}

export const offers = createQueryKeys('offers', {
    detail: (id: string) => ({
        queryKey: [id],
        queryFn: () => getOfferById(id),
        contextQueries: {
            messages: {
                queryKey: null,
                queryFn: () => getMessages(id),
            },
            offerMessages: {
                queryKey: null,
                queryFn: () => getMessagesForOfferId(id),
            },
            initialEnquiry: {
                queryKey: null,
                queryFn: () => getInitialEnquiry(id),
            },
            history: {
                queryKey: null,
                queryFn: () => getOfferHistory(id),
            },
            fees: {
                queryKey: null,
                queryFn: () => getFeeForOfferId(id),
            },
            validation: (offer: any) => ({
                queryKey: [offer],
                queryFn: () => validateOffer({ offerId: id, offer }),
            }),
            approvalSettings: {
                queryKey: null,
                queryFn: () => getOfferApprovalSettings(id),
            },
            positions: {
                queryKey: null,
            },
        },
    }),
    list: (params: GetOfferListParams) => ({
        queryKey: [{ params }],
        queryFn: () => getOfferList(params),
    }),
    pagination: (params: GetOffersParams) => ({
        queryKey: [{ params }],
        queryFn: () => getOffers(params),
    }),
    comboBoxOptions: (searchQuery: string) => ({ queryKey: [{ searchQuery }] }),
    selectedComboBoxOption: (offerId: string) => ({ queryKey: [{ offerId }] }),
    totals: (params: GetOffersTotalsParams) => ({
        queryKey: [{ params }],
    }),
    totalFee: (offerTotal: number, currencyCode: string) => ({
        queryKey: [offerTotal, currencyCode],
        queryFn: () => getFeeForOfferTotal(offerTotal, currencyCode),
    }),
});
